import { isUrlValid } from "../urlValidation";
import { VIDEO_PROVIDER_LIST } from "../../configs/constants";

export const detectProvider = (url = "") => {
  const isURL = isUrlValid(url);
  const youTubeParser = (url) => {
    let ID = "";
    const cleanUrl = url.replace(/(>|<)/gi, "");

    const shortsMatch = cleanUrl.match(
      /(?:youtube\.com\/shorts\/|youtu\.be\/shorts\/)([a-zA-Z0-9_-]{11})/
    );
    if (shortsMatch) {
      return shortsMatch[1];
    }

    const urlParts = cleanUrl.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);

    if (urlParts[2] !== undefined) {
      ID = urlParts[2].split(/[^0-9a-z_-]/i);
      ID = ID[0];
    } else {
      ID = null;
    }
    return ID;
  };

  const isFacebookVideo = (url) => {
    const facebookPattern = /(?:https?:\/\/)?(?:www\.)?(?:facebook\.com|fb\.watch)\//;
    if (facebookPattern.test(url)) {
      return url;
    }
    return null;
  };

  const isVimeoVideo = (url) => {
    // eslint-disable-next-line
    var result = url.match(/(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_\-]+)?/i);
    return result[1]
  };

  if (isURL) {
    try {
      const response = isFacebookVideo(url);
      if (response)
        return {
          name: VIDEO_PROVIDER_LIST[1].name,
          data: { id: response },
        };
    } catch (error) {
    }

    try {
      const response = youTubeParser(url);
      if (response)
        return { name: VIDEO_PROVIDER_LIST[0].name, data: { id: response } };
    } catch (error) {
    }

    try {
      const response = isVimeoVideo(url);
      if (response)
        return {
          name: VIDEO_PROVIDER_LIST[2].name,
          data: { id: response },
        };
    } catch (error) {
    }
  }

  return null;
};
